<template>
    <div class="TargetEditor">
        <h3>{{ Description }}: <span @click="ShowCreateTarget()" class="pointer olive-green-text"><i class="fa fa-plus" /></span></h3>
        <table class="table-utility" style="margin-bottom: 35px;">
            <thead>
                <tr>
                    <th>Daily Target</th>
                    <th>Weekly Target</th>
                    <th>Monthly Target</th>
                    <th>Effective Date</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="target in Targets" :class="{lightblueback: RowIsCurrentRange(target)}">
                    <td>{{target.Target}}</td>
                    <td>{{target.WeeklyTarget}}</td>
                    <td>{{target.MonthlyTarget}}</td>
                    <td>{{formatDate(target.StartDate)}}</td>
                    <td><span @click="DeleteTarget(target.Id)" class="pointer red"><i class="red fa fa-trash-alt" /></span></td>
                </tr>
            </tbody>
        </table>

        <!--CREATE MODAL-->
        <b-modal ref="create-modal" :title="'Add Target: ' + Description" hide-footer>
            <b-container>
                <b-form @submit="CreateTarget">
                    <b-row>
                        <b-col>
                            <p><span class="bold">Instructions: </span> Enter a <span class="bold">DAILY</span> goal for this target.  If you have a weekly goal in mind, divide that number by 7.  If you have a monthly goal in mind, divide that number by 30.41667.  This will allow you to use the same goal accross multiple time ranges: Daily, Weekly, Monthly.</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Daily Target:</label>
                                <input class="form-control" type="number" v-model="NewTarget.Target" required step="0.0000001" />
                            </div>
                            <div class="form-group">
                                <label>Effective Date:</label>
                                <flat-pickr v-model="NewTarget.StartDate" class="form-control" :config="DateConfig" required></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelCreateTarget()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
        
    </div>
</template>

<script>
    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        name: "TargetEditor",
        props: [
            "Description",
            "TargetName",
            "PrimarySpecifier",
            "SecondarySpecifier",
            "CoreProgramSpecifier",
            "EmployeeSpecifier",
            "SubProgramSpecifier",
            "RegionSpecifier"
        ],
        data: function () {
            return {
                Targets: [],
                NewTarget: {},
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false
                },
            };
        },
        methods: {
            //UI
            ShowCreateTarget() {
                this.NewTarget = {
                    Target: "",
                    StartDate: ""
                };
                this.$refs['create-modal'].show();
            },
            CancelCreateTarget() {
                this.$refs['create-modal'].hide();
            },
            //API
            GetData() {
                this.$MasterAPI.ExecuteRequest(
                    "GET",
                    "Dashboards/ExpectedTargets",
                    {
                        Name: this.TargetName,
                        PrimarySpecifier: this.PrimarySpecifier,
                        SecondarySpecifier: this.SecondarySpecifier,
                        CoreProgramSpecifier: this.CoreProgramSpecifier,
                        EmployeeSpecifier: this.EmployeeSpecifier,
                        SubProgramSpecifier: this.SubProgramSpecifier,
                        RegionSpecifier: this.RegionSpecifier
                    },
                    this.GetDataSuccess,
                    () => { },
                    true);
            },
            GetDataSuccess(response) {
                this.Targets = response.data.data;
            },
            DeleteTarget(id) {
                this.$MasterAPI.ExecuteRequest(
                    "DELETE",
                    "Dashboards/ExpectedTargets/" + id,
                    {},
                    this.GetDataSuccess,
                    () => { },
                    true);
            },
            CreateTarget(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest(
                    "POST",
                    "Dashboards/ExpectedTargets",
                    {
                        Name: this.TargetName,
                        PrimarySpecifier: this.PrimarySpecifier,
                        SecondarySpecifier: this.SecondarySpecifier,
                        CoreProgramSpecifier: this.CoreProgramSpecifier,
                        EmployeeSpecifier: this.EmployeeSpecifier,
                        SubProgramSpecifier: this.SubProgramSpecifier,
                        RegionSpecifier: this.RegionSpecifier,
                        Target: this.NewTarget.Target,
                        StartDate: this.NewTarget.StartDate
                    },
                    this.CreateTargetSuccess,
                    () => { },
                    true);
            },
            CreateTargetSuccess(response) {
                this.CancelCreateTarget();
                this.GetDataSuccess(response);
            },
            //AUX
            formatDate(value, fmt = 'MM/DD/YYYY', defaultVal = '') {
                return (value == null)
                    ? defaultVal
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            RowIsCurrentRange(rowTarget) {
                let now = moment().format("YYYY-MM-DD");
                let start = this.formatDate(rowTarget.StartDate, 'YYYY-MM-DD');
                let end = this.formatDate(rowTarget.EndDate, 'YYYY-MM-DD', '9999-99-99');
                console.log(now + "xxx" + start + "xxx" + end);
                if (now >= start && now <= end) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        components: {
            flatPickr
        },
        mounted() {
            this.GetData();
        },
        watch: {
            Description(newValue, oldValue) {
                this.GetData();
            },
        },
        computed: {

        }
    }
</script>

<style scoped>

</style>